import type { CustomParamsSerializer } from '../../lib/axios';

type QueryParams = Record<string, string | string[] | undefined>;

const paramsSerializer: CustomParamsSerializer = (params: QueryParams) => {
  const queryStringArray: string[] = [];

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      if (Array.isArray(value)) {
        for (const val of value) {
          queryStringArray.push(
            `${encodeURIComponent(key)}[]=${encodeURIComponent(val)}`
          );
        }
      } else {
        queryStringArray.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        );
      }
    }
  }

  return queryStringArray.join('&');
};

export default paramsSerializer;
